/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section7_P1Inputs */

const en_terms_section7_p1 = /** @type {(inputs: Terms_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For questions about these terms, contact the maintainer at the address below or open an issue on the GitHub repository.`)
};

const ko_terms_section7_p1 = /** @type {(inputs: Terms_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`본 약관에 대한 문의는 아래 주소로 운영자에게 연락하거나 GitHub 저장소에 이슈를 등록해 주세요.`)
};

const ja_terms_section7_p1 = /** @type {(inputs: Terms_Section7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本規約についてのご質問は、下記アドレスから運営者にご連絡いただくか、GitHub リポジトリで issue を作成してください。`)
};

/**
* | output |
* | --- |
* | "For questions about these terms, contact the maintainer at the address below or open an issue on the GitHub repository." |
*
* @param {Terms_Section7_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section7_p1 = /** @type {((inputs?: Terms_Section7_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section7_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section7_p1(inputs)
	if (locale === "ko") return ko_terms_section7_p1(inputs)
	return ja_terms_section7_p1(inputs)
});